import styled from "styled-components";
import { theme } from "../../../config";

export const Container = styled.div`
  width: 620px;
  height: 577px;
  background: ${theme.colors.white};
  border-radius: 8px;
  ${theme.defaultContainerBoxShadow}
  @media ${theme.breakpoints.mobile} {
    height: 100%;
  }
`;

export const Header = styled.div`
  text-align: center;
  marginn-top: ;
`;

export const Logo = styled.img`
  width: 164px;
  margin-top: 80px;

  @media ${theme.breakpoints.mobile} {
    margin-top: 21px;
    height: 24px;
  }
`;

export const HeaderText = styled.h1`
  font-family: Orkney Bold;
  margin-top: 43px;
  font-size: 34px;
  line-height: 48px;

  @media ${theme.breakpoints.mobile} {
    margin-top: 27px;
    font-size: 21.6px;
    line-height: 26px;
  }
`;

export const Body = styled.div`
  margin: 44px 111px 0 111px;
  ${theme.formErrorMobileView}

  @media ${theme.breakpoints.mobile} {
    margin: 35px 16px 0 16px;
  }
`;

export const ButtonWrapper = styled.div`
  text-align: center;
  margin-top: 20px;
`;

export const BackToLoginWrapper = styled.div`
  margin-top: 40px;
  text-align: center;
`;

export const InputWrapper = styled.div`
  height: 85px;
`;

export const ErrorMessage = styled.span`
  color: ${theme.colors.utilities.error};
`;
